module.exports = __webpack_public_path__ + "static/media/showers.914aab08.png";